import { DatePicker, Form, Modal, Select, Skeleton, Spin } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast"; 
import { formattedDate } from "../../../utils";

function PayoutHistoryModal({ open, handleCancel }) {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const formRef = useRef(null);

  const { orgCode, orgWalletCode, loading } = useSelector(
    (state) => state.dropdown
  );
  const { saving } = useSelector((state) => state.auth);
  const [reportUrl, setReportUrl] = useState("");

  const onFinish = async (data) => {
    const generatedUrl = `http://102.217.125.47/myReports/generateInlineReport.action?rptId=1&P_START_DATE=${formattedDate(
      data?.P_START_DATE?.$d
    )}&P_END_DATE=${formattedDate(
      data?.P_END_DATE?.$d
    )}&P_WAL_CODE=${orgWalletCode}&orgCode=${orgCode}&instType=ORGANIZATION&PDF_FORMAT=PDF&P_FORMAT=PDF`;
    await setReportUrl(generatedUrl);
    window.open(generatedUrl, "_blank", "width=1200,height=800");
  };
  const handleModalCancel = async () => {
    await form.resetFields();
    await handleCancel();
    await setReportUrl("");
  };

  return (
    <Modal
      className="modal-btn mod-height mod-footer"
      title={`Generate payout history report`}
      open={open}
      onOk={form.submit}
      onCancel={handleModalCancel}
      width={850}
    >
      <Form
        layout="vertical"
        ref={formRef}
        name="control-ref"
        onFinish={onFinish}
        className=" "
        style={{
          maxWidth: "100%",
        }}
        form={form}
      >
        <Form.Item
          name="P_START_DATE"
          rules={[
            {
              required: true,
              message: "Field is required",
            },
          ]}
          label="Start Date"
        >
          <DatePicker className="input" format={"YYYY-MM-DD"} />
        </Form.Item>
        <Form.Item
          name="P_END_DATE"
          rules={[
            {
              required: true,
              message: "Field is required",
            },
          ]}
          label="End Date"
        >
          <DatePicker className="input" format={"YYYY-MM-DD"} />
        </Form.Item>
        <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
          <div className="justify-start"></div>
          <div className="justify-end flex items-center gap-x-2">
            <div className="w-[200px]">
              <button
                key="back"
                type="button"
                onClick={handleModalCancel}
                className="cstm-btn !bg-white !text-lightBlack !border !border-lightBlack"
              >
                Cancel
              </button>
            </div>

            <div className="w-[250px]">
              <button
                key="submit"
                type="submit"
                className="cstm-btn"
                disabled={saving}
              >
                {saving ? <Spin /> : "   Generate Report"}
              </button>
            </div>
          </div>
        </div>
      </Form>
    </Modal>
  );
}

export default PayoutHistoryModal;
